var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import Numeric from "./Numeric";

export default class NumericRange extends Component {
  constructor(props) {
    super(props);
    const value = props.value || {};
    this.state = { from: value.from, to: value.to };
  }

  onChange(prop, value) {
    const newState = _objectSpread(_objectSpread({},
    this.state), {}, {
      [prop]: value });


    this.setState(newState);

    const { from, to } = newState;

    this.props.onChange(_objectSpread(_objectSpread({},
    from !== '' ? { from } : {}),
    to !== '' ? { to } : {}));

  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "Numeric__From" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Label date \"From\"" }, void 0, "From:"), /*#__PURE__*/
      _jsx(Numeric, { value: this.state.from, onChange: (val) => this.onChange('from', val) })), /*#__PURE__*/

      _jsx("div", { className: "Numeric__To" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Label date \"to\"" }, void 0, "To:"), /*#__PURE__*/
      _jsx(Numeric, { value: this.state.to, onChange: (val) => this.onChange('to', val) }))));



  }
}